import {
  checkCompanyRegistrationNumber,
  getAlertMessageFunction,
  getCurrentYear,
  isValidDate,
} from '../../../common/Util';

//   국세청구분 : v.htm016
// 구분코드 : v.htm005
// 상호 : v.htm002
// 사업자번호 : v.htm001
// 기부내용 : v.htm003
// 기부일 : v.htm008
// 일련번호 : v.htm009
// 건수 : v.htm006
// 금액 : v.htm007
// 전년도 공제액 : v.htm027
// 이월된 기부금 : v.htm028
// 기부장려금 : v.htm031

export const isValidate = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();
  const currentYear = getCurrentYear();

  const hasError = dataList.some(data => {
    const {
      htm016,
      htm005,
      htm002,
      htm001,
      htm003,
      htm008,
      htm009,
      htm006,
      htm007,
      htm027,
      htm028,
      htm031,
    } = data;

    //국세청외일괄, 자동이월은 유효성체크안함
    if (['3', '4', '5'].includes(htm016)) {
      return false;
    }

    // 국세청구분을 선택하지 않은 경우
    if (htm016 === '') {
      alertMessage(t('alertMessage.message1'), 'error');
      return true;
    }

    // 구분코드를 선택하지 않은 경우
    if (htm005 === '') {
      alertMessage(t('alertMessage.message2'), 'error');
      return true;
    }

    // 자동이월 기부금은 입력하지 마라
    // if (['4', '5'].includes(htm016)) {
    //   alertMessage(t('alertMessage.message3'), 'error');
    //   return true;
    // }

    // 올해 기부금은 자동이월 X 올해 년도로 해야 되나
    if (htm008.substring(0, 4) === currentYear && ['4', '5'].includes(htm016)) {
      alertMessage(t('alertMessage.message4', { year: currentYear }), 'error');
      return true;
    }

    // 사업자번호 입력
    if (htm001 === '' && !['1', '4', '5', '20'].includes(htm016)) {
      alertMessage(t('alertMessage.message5'), 'error');
      return true;
    }

    // 정확한 날짜 입력
    if (htm008.length > 10) {
      alertMessage(t('alertMessage.message6'), 'error');
      return true;
    }

    // 사업자번호 또는 주민번호의 자리수와 맞지 않습니다.
    if (
      htm001 !== '' &&
      htm001.replaceAll('-', '').length != 10 &&
      htm001.replaceAll('-', '').length != 13
    ) {
      alertMessage(t('alertMessage.message7'), 'error');
      return true;
    }

    //맞지 않는 사업자번호
    if (
      htm016 != '1' &&
      htm016 != '4' &&
      htm016 != '5' &&
      htm005 != '20' &&
      htm001.replaceAll('-', '').length == 10 &&
      !checkCompanyRegistrationNumber(htm001)
    ) {
      alertMessage(t('alertMessage.message22'), 'error');
      return true;
    }

    //주민 유효성 체크해야함

    // 정치자금외 기부금 상호입력
    if (htm005 !== '20' && !['4', '5'].includes(htm016) && htm002 === '') {
      alertMessage(t('alertMessage.message8'), 'error');
      return true;
    }

    // 정치자금외 기부금은 사업자
    if (htm005 !== '20' && !['4', '5', '1'].includes(htm016) && htm001 === '') {
      alertMessage(t('alertMessage.message9'), 'error');
      return true;
    }

    // 정치자금외 기부금은 일련번호
    if (htm005 !== '20' && !['4', '5', '1'].includes(htm016) && htm009 === '') {
      alertMessage(t('alertMessage.message10'), 'error');
      return true;
    }

    // 금액 입력 //PC는 0원 입력할 수 있어서 맞춤 (국세청 자료에도 가끔0원들어옴)
    if (htm007 === '') {
      alertMessage(t('alertMessage.message11'), 'error');
      return true;
    }

    // 현재년도에 기부한 건 전년도 공제액 및 이월액 입력X
    if (
      htm008.substring(0, 4) === currentYear &&
      ((htm027 !== '' && htm027 !== '0') || (htm028 !== '' && htm028 !== '0'))
    ) {
      alertMessage(t('alertMessage.message12', { year: currentYear }), 'error');
      return true;
    }

    // 현재년도 이후 기부금 입력X
    if (htm008.substring(0, 4) > currentYear) {
      alertMessage(t('alertMessage.message13', { nextYear: Number(currentYear) + 1 }), 'error');
      return true;
    }

    if (Number(htm008.substring(0, 4)) < Number(currentYear) - 10) {
      alertMessage(t('alertMessage.message14'), 'error');
      return true;
    }

    // ~년에 기부하신 기부금은 전년도 공제액 및 이월액을 입력하셔야 합니다.
    if (
      htm008.substring(0, 4) < currentYear &&
      (htm027 === '' || htm027 === '0') &&
      (htm028 === '' || htm028 === '0')
    ) {
      alertMessage(`${htm008.substring(0, 4)}${t('alertMessage.message15')}`, 'error');
      return true;
    }

    // 전년도 공제액과 이월액의 합계가 총 기부금액과 일치하지 않습니다.
    if (
      htm008.substring(0, 4) < currentYear &&
      Number(htm027) + Number(htm028) !== Number(htm007)
    ) {
      alertMessage(t('alertMessage.message16'), 'error');
      return true;
    }

    // 법정기부금, 지정기부금, 종교단체기부금만 이월이 가능합니다.
    if (
      htm005 !== '10' &&
      htm005 !== '40' &&
      htm005 !== '41' &&
      htm008.substring(0, 4) !== currentYear
    ) {
      alertMessage(t('alertMessage.message17'), 'error');
      return true;
    }

    //셀렉트박스에서 국세청외만 선택할수 있기때문에 삭제함 25.01.15 선희
    // 국세청외일괄은 선택할 수 없습니다.
    // if (htm016 === '3') {
    //   alertMessage(t('alertMessage.message18'), 'error');
    //   return true;
    // }

    // 2016년 이전에 기부하신 기부금은 장려기부금을 입력할 수 없습니다.
    if (htm008.substring(0, 4) < '2016' && htm031 !== '') {
      alertMessage(t('alertMessage.message19'), 'error');
      return true;
    }

    // 기부금액보다 많은 기부장려금은 입력할 수 없습니다. //국세청자료제외 25.01.17선희
    if (htm016 != '1' && htm031 !== '' && Number(htm007) < Number(htm031)) {
      alertMessage(t('alertMessage.message20'), 'error');
      return true;
    }

    //장려기부금은 특례기부금, 지정기부금, 종교단체기부금만 입력 가능합니다.
    if (htm016 == '2' && htm031 > 0 && htm005 !== '10' && htm005 !== '40' && htm005 !== '41') {
      alertMessage(t('alertMessage.message23'));
      return true;
    }

    // 기부일을 잘못 입력
    if (!isValidDate(htm008)) {
      alertMessage(t('alertMessage.message21'), 'error');
      return true;
    }

    return false;
  });

  return !hasError;
};
